import React, { Component } from 'react'
import PropTypes from 'prop-types'
import SuccessLander from 'components/SuccessLander'
import PURPLE_ARROW from './purple-arrow.svg'
import { track } from 'utils/trackingUtils'
import { Button } from '@drifthq/tide-core'
import CopyToClipboard from 'react-copy-to-clipboard'
import { take, length } from 'ramda'
import config from 'config'
import { RefreshButton, onExitOnboarding } from '../BotWoohoo'

import './style.css'

const MAX_LINK_LENGTH = 40

class ClpWoohoo extends Component {

  static propTypes = {
    playbookId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    playbookType: PropTypes.string.isRequired,
    landingPageSettings: PropTypes.object.isRequired,
    landingPageCname: PropTypes.string,
    landingPageSubdomain: PropTypes.string
  }

  constructor(props) {
    super(props)
    this.state = {
      isModalOpen: false,
      copied: false,
    }
  }

  componentDidMount() {
    const { name, playbookId, playbookType } = this.props
    track(`${name} - Playbook Created`, { playbookId: playbookId, playbookName: playbookType, targeting: 'landing-page' })
  }

  trackCopy = () => {
    const { playbookId, playbookType } = this.props
    track('Onboarding Playbook - CLP Link Copied', { playbookId: playbookId, playbookName: playbookType })
  }

  onCopy = () => {
    this.setState({ copied: true })

    setTimeout(() => {
      this.setState({ copied: false })
    }, 1000)
  }

  getLinkPreview = (link) => {
    return length(link) > MAX_LINK_LENGTH ? `${take(30, link)}...`: link
  }

  refreshClp = () => {
    var iframe = document.getElementById('clpFrame')
    iframe.src = iframe.src
  }

  render() {
    const { playbookId } = this.props
    const landingPageDomain = `${this.props.landingPageCname || (this.props.landingPageSubdomain + '.' + config.PAGES_HOST)}`
    const clpLink = `https://${landingPageDomain}/t/${this.props.landingPageSettings.path}`
    const previewClpLink = this.getLinkPreview(clpLink)
    const { copied } = this.state

    return (
      <div className="clp-woohoo-container">
        <div className="clp-woohoo-left-panel">
          <SuccessLander
            className="clp-woohoo-submit-button"
            subheaderText={"Share your bot and start collecting leads using the link below 👇🏻"}
            headerText={<div>Woohoo! <br />Your bot is ready</div>} buttonText="Customize my bot further"
            onButtonClick={() => onExitOnboarding(playbookId)}>
            <div className="clp-woohoo-link-wrapper">
            <div className="clp-woohoo-link">
              {previewClpLink}
              </div>
              <CopyToClipboard text={clpLink} onCopy={this.onCopy}>
            <Button type="secondary" onClick={this.trackCopy}>
            {copied ? "Copied": "Copy Link"}
            </Button>
            </CopyToClipboard>
            </div>
          </SuccessLander>
        </div>

        <div className="clp-woohoo-right-panel">
          <div className="clp-woohoo-tip-wrapper">
            <div className="clp-woohoo-tip">
            <img className="clp-woohoo-tip-arrow" alt="tip-arrow" src={PURPLE_ARROW} />
              Preview your bot here!
              </div>
            <RefreshButton onRefresh={this.refreshClp} className="clp-woohoo-refresh"/>
            </div>
          <iframe id="clpFrame" title="clp" className="clp-woohoo-iframe" src={clpLink}></iframe>
        </div>
      </div>
    )
  }
}

export default ClpWoohoo


// WEBPACK FOOTER //
// ./src/layouts/OnboardingPlaybookWoohooStep/ClpWoohoo/index.js